<!--
 * @Author: wankong
 * @Desc: 
 * @Date: 2022-01-09 13:55:37
 * @LastEditTime: 2022-01-10 16:05:59
-->
<template>
  <div class="MMain">
    <div class="container">
      <div class="header">
        <div class="logo">
          <img src="../../assets/logo.png" alt="" />
        </div>
        <div class="desc">
          <div class="titles">
            <h3 v-for="title in titles" :key="title">
              {{ title }}
            </h3>
          </div>
          <p>在千万题库中搜索</p>
        </div>
      </div>
      <div class="searchBox">
        <div class="search">
          <div class="ico">
            <svg width="30" height="30" viewBox="0 0 48 48" fill="none">
              <path
                d="M33.07 33.071c6.25-6.248 6.25-16.379 0-22.627-6.248-6.249-16.378-6.249-22.627 0-6.248 6.248-6.248 16.379 0 22.627 6.249 6.248 16.38 6.248 22.628 0zm0 0l8.486 8.485"
                stroke="#4E5969"
                stroke-width="4"
              />
            </svg>
          </div>
          <input
            type="text"
            autofocus
            v-model="formData.question"
            @keypress.enter="search"
            placeholder="搜点什么吧（不少于三个字）"
          />
          <MButton
            class="searchBtn"
            :loading="isloading"
            @click="search"
            :disabled="!canSubmit"
            >搜索</MButton
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MButton from "@/components/common/Button";
import { search } from "@/api/home";
import { getToken } from "../../utils/role";
export default {
  components: {
    MButton,
  },
  data() {
    return {
      titles: [
        "你不会的，这里也有",
        "千万题库，尽在掌握",
        "毫秒级的响应，让快更快",
        "Free For Everyone",
      ],
      formData: {
        question: "马克思",
        platform: "web",
        timestamp: new Date().getTime(),
        token: getToken(),
      },
      isloading: false,
    };
  },
  computed: {
    canSubmit() {
      return this.formData.question.length >= 3;
    },
  },
  methods: {
    search() {
      // todo  发送网络请求;
      this.isloading = true;
      search(this.formData).then((res) => {
        this.isloading = false;

        if (res.code == 200) {
          this.res = res.data;
          this.$store.commit("upResult", {
            question: this.formData.question,
            show: true,
            datas: res.data.datas,
          });
        } else {
          this.$tip.danger(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.MMain {
  padding-top: 100px;
  height: 50%;
  width: 100%;
  background: linear-gradient(
      -30deg,
      #cc99ff,
      #ece4f3,
      #fce2c4,
      #fef4b4,
      #79d2d2
    )
    0% 0% / cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  .container {
    width: 768px;
    height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .header {
      user-select: none;
      display: flex;
      flex-direction: column;
      align-items: center;
      .logo {
        width: 100px;
        height: 100px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .desc {
        text-align: center;
        .titles {
          height: 4rem;
          font: Bold 2.6rem/4rem "SourceHanSansCN_Bold";
          overflow: hidden;
          &:hover {
            h3 {
              animation-play-state: paused;
            }
          }
          h3 {
            animation: titles 10s linear alternate infinite;
          }
        }
        p {
          font: 1.2rem/1.4rem "SourceHanSansCN_Bold";
          opacity: 0.8;
        }
      }
    }
    .searchBox {
      margin-top: 100px;
      width: 100%;
      background: #fff;
      border-radius: 10px;
      position: relative;
      .search {
        width: calc(100% - 7rem);
        display: flex;
        border-radius: 10px;
        padding: 1rem;
        align-items: center;
        justify-content: center;
        box-shadow: 10px 10px 100px #ffffff;
        input {
          display: inline-block;
          flex: 1;
          margin-left: 1rem;
          border: none;
          outline: none;
          font-size: 20px;
        }
      }
      .searchBtn {
        width: 7rem;
        border-radius: 0 10px 10px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        box-shadow: none;
        height: 100%;
        right: 0;
        position: absolute;
        padding: 0.1rem;
        font-size: larger;
      }
    }
  }
}
@keyframes titles {
  0% {
    transform: translateY(0%);
  }
  24% {
    transform: translateY(0%);
  }
  26% {
    transform: translateY(-100%);
  }
  49% {
    transform: translateY(-100%);
  }
  52% {
    transform: translateY(-200%);
  }
  74% {
    transform: translateY(-200%);
  }
  76% {
    transform: translateY(-300%);
  }
  99% {
    transform: translateY(-300%);
  }
}
</style>
